import * as yup from "yup";
import { useTranslation } from "react-i18next";

export const appl191ValidationSchema = () => {
  const { t } = useTranslation();
  return yup
    .object()
    .shape({
      d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
      boardDate: yup
        .date()
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
      acceptedFinancialReport: yup
        .string()
        .required(t("Το πεδίο είναι υποχρεωτικό")),
      fudocIsologismos: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
      fudocEkthesiDS: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
      fudocWeb: yup.string().nullable(),
      webDate: yup
        .date()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
        .nullable(),
      webURL: yup.string().nullable(),
      paperDate: yup
        .date()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
        .nullable(),
      paperName: yup.string().nullable(),
      fudocPaper: yup.string().nullable(),
      usageFromDate: yup
        .date()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .max(
          new Date("2016-07-07"),
          t(
            "Η ημερομηνία λήξης χρήσης δεν μπορεί να είναι μετά την 07/07/2016."
          )
        )
        .test(
          "is-before",
          t(
            "Η ημερομηνία 'Ισολογισμού Χρήσης Από' πρέπει να είναι πριν από την ημερομηνία 'Ισολογισμού Χρήσης Έως'."
          ),
          function (value) {
            const { usageToDate } = this.parent;
            if (
              value &&
              usageToDate &&
              new Date(value) > new Date(usageToDate)
            ) {
              return false;
            }
            return true;
          }
        ),
      usageToDate: yup
        .date()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .max(
          new Date("2016-07-07"),
          t(
            "Η ημερομηνία λήξης χρήσης δεν μπορεί να είναι μετά την 07/07/2016."
          )
        ),
    })
    .test(
      "has filled all of website",
      t(
        "Εάν επιθυμείτε να εισάγετε τα στοιχεία της ιστοσελίδας, πρέπει να συμπληρώσετε όλα τα αντίστοιχα πεδία."
      ),
      function (value) {
        if (!value || typeof value !== "object") {
          return true;
        }

        const fudocWeb = value.fudocWeb?.trim() || null;
        const webDate = value.webDate ?? null;
        const webURL = value.webURL?.trim() || null;

        if (!fudocWeb && !webDate && !webURL) {
          return true;
        }

        let hasError = false;

        if (!fudocWeb) {
          hasError = true;
          this.createError({
            path: "fudocWeb",
            message: t(
              "Εάν επιθυμείτε να εισάγετε τα στοιχεία της ιστοσελίδας, πρέπει να συμπληρώσετε όλα τα αντίστοιχα πεδία."
            ),
          });
        }
        if (!webDate) {
          hasError = true;
          this.createError({
            path: "webDate",
            message: t(
              "Εάν επιθυμείτε να εισάγετε τα στοιχεία της ιστοσελίδας, πρέπει να συμπληρώσετε όλα τα αντίστοιχα πεδία."
            ),
          });
        }
        if (!webURL) {
          hasError = true;
          this.createError({
            path: "webURL",
            message: t(
              "Εάν επιθυμείτε να εισάγετε τα στοιχεία της ιστοσελίδας, πρέπει να συμπληρώσετε όλα τα αντίστοιχα πεδία."
            ),
          });
        }

        return hasError ? false : true;
      }
    )

    .test(
      "has filled all of paper",
      t(
        "Εάν επιθυμείτε να εισάγετε τα στοιχεία της εφημερίδας, πρέπει να συμπληρώσετε όλα τα αντίστοιχα πεδία."
      ),
      function (value) {
        if (!value || typeof value !== "object") {
          return true;
        }

        const fudocPaper = value.fudocPaper?.trim() || null;
        const paperDate = value.paperDate ?? null;
        const paperName = value.paperName?.trim() || null;

        if (!fudocPaper && !paperDate && !paperName) {
          return true;
        }

        let hasError = false;

        if (!fudocPaper) {
          hasError = true;
          this.createError({
            path: "fudocPaper",
            message: t(
              "Εάν επιθυμείτε να εισάγετε τα στοιχεία της εφημερίδας, πρέπει να συμπληρώσετε όλα τα αντίστοιχα πεδία."
            ),
          });
        }
        if (!paperDate) {
          hasError = true;
          this.createError({
            path: "paperDate",
            message: t(
              "Εάν επιθυμείτε να εισάγετε τα στοιχεία της εφημερίδας, πρέπει να συμπληρώσετε όλα τα αντίστοιχα πεδία."
            ),
          });
        }
        if (!paperName) {
          hasError = true;
          this.createError({
            path: "paperName",
            message: t(
              "Εάν επιθυμείτε να εισάγετε τα στοιχεία της εφημερίδας, πρέπει να συμπληρώσετε όλα τα αντίστοιχα πεδία."
            ),
          });
        }

        return hasError ? false : true;
      }
    );
};
